export const RELEASE_LINE = {
  angular: '7.2.x',
  packageVersion: '7.0.0',
  coreVersion: '0.1.1',
  runtimeTarget: 'Angular 7 + Angular CLI',
  docsPath: '/angular-7/'
};
